<script>
    import { onMount, createEventDispatcher } from 'svelte'
    export let icon = 'far fa-arrow-right'
    export let name
    export let label = 'Label'
    export let value = ''
    export let type = 'input'
    export let editable = true
    export let nullable = true
    export let placeholder = ''
    export let field = null
    export let invalid = false


    let focused = false
    // let invalid = false
    let field_props = {
        name: name,
        placeholder: placeholder,
        autocomplete: 'off'
    }

    const dispatch = createEventDispatcher ();
    const packField = () => {
        if (type === 'textarea' && field) {
            field.style.height = '1px';
            field.style.height = field.scrollHeight + 'px';
        }
    }
    const onBlockClick = (e) => {
        focusField ();
        dispatch ('clicked', {
            name,
            label
        })
    }
    const focusField = () => {
        if (editable && field)
            field.focus ();
    }
    const onFocus = (e) => {
        placeCaretAtEnd (e.target);
        focused = true
    }
    const onFocusOut = () => {
        focused = false
    }
    const handleChange = (event) => {
        let val = event.target.value;

        if (type === 'number') {
            let vv  = val.replace(/\D/, '');
            val = (vv !== '' ? parseInt (vv) : 0);
        }
        
        invalid = nullable ? false : val.trim().length === 0;
        packField ();
        dispatch ('fieldchange', {
            name: name,
            value: val,
            valid: invalid === false
        })
    }

    function placeCaretAtEnd (element) {
        element.setSelectionRange(element.value.length, element.value.length);
    }

    onMount (packField)
</script>

<div class="SmartField" class:focused class:invalid on:click={onBlockClick}>
    <div class="lbl bold">{label}</div>
    {#if type === 'textarea'}
        <textarea bind:this={field} class="ta" disabled={editable === false} on:focusin={onFocus} 
            on:focusout={onFocusOut} on:input={handleChange} bind:value={value} {...field_props}></textarea>
    {:else if type === 'input'}
        <input type="text" bind:this={field} class="ti" disabled={editable === false} bind:value={value} on:input={handleChange} autocomplete="off" {...field_props} />
    {:else if type === 'password'}
        <input type="password" bind:this={field} class="ti" disabled={editable === false} bind:value={value} on:input={handleChange} autocomplete="off" {...field_props} />
    {:else if type === 'number'}
        <input type="text" bind:this={field} class="ti" disabled={editable === false} value={value} on:input={handleChange} autocomplete="off" {...field_props} />
    {/if}
    
    <i class="{icon} go-icon"></i>
</div>

<style>
    .SmartField {
        position: relative;
        background-color: #ecf2f6;
        padding: 5px 20px 5px 10px;
        border-radius: 3px;
        margin-bottom: 10px;
        font-size: 14px;
    }
    .SmartField.focused {
        background-color: #d6e2ea;
    }
    .SmartField.invalid {
        background-color: #ff7675;
        color: #fff;
    }
    .SmartField .ta {
        width: 100%;
        border: none;
        background: none;
        resize: none;
        padding: 0;
        color: #4a727f;
        font-size: 14px;
        margin: 0;
        outline: none;
        pointer-events: none;
    }
    .SmartField .ti {
        width: 100%;
        border: none;
        background: none;
        padding: 0;
        color: #4a727f;
        font-size: 14px;
        margin: 0;
        outline: none;
        pointer-events: none;
    }
    .SmartField.focused .ta {
        pointer-events: auto;
    }
    .SmartField .go-icon {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
    }
    .SmartField :global(::-webkit-input-placeholder) {
        color: #a1b7c1
    }
    .SmartField.invalid :global(::-webkit-input-placeholder) {
        color: rgba(255, 255, 255, .7)
    }
</style>